export const painPoints = [
  {
    emoji: '🧭',
    title: 'Nereden başlayacağınızı bilemiyor musunuz?',
    desc: 'Boş bir sayfadan başlamak zor olabilir. Bu sistem; olay raporları, tutanaklar, delil kayıtları ve idari belgeler için yapılandırılmış başlangıç noktaları sunar.',
  },
  {
    emoji: '🔤',
    title: 'Profesyonel terminoloji konusunda zorlanıyor musunuz?',
    desc: 'Tahmin yürütmek yerine, daha düzenli ve nesnel bir anlatım oluşturmanıza yardımcı olan yapılandırılmış komutlardan yararlanın.',
  },
  {
    emoji: '🧩',
    title: 'Yapay zekâ çıktısının doğal görünmemesinden endişe ediyor musunuz?',
    desc: 'Genel amaçlı komutlar her zaman ihtiyacınıza uygun sonuç vermeyebilir. Daha ayrıntılı talimatlar, belirli bir raporlama amacına uygun çıktılar hazırlamanıza yardımcı olabilir.',
  },
  {
    emoji: '🎯',
    title: 'Vardiyanızı zamanında bitirmek istiyor musunuz?',
    desc: 'Uzun bir vardiyanın ardından saatlerce evrak hazırlamak sürdürülebilir olmayabilir. Tekrarlanan görevler için hazır komutlar, çalışma sürecinizi daha verimli organize etmenize yardımcı olabilir.',
  },
];
